module.exports = function (el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _require = require('./scrollspy'),
    ScrollSpy = _require.ScrollSpy;
  var instance = new ScrollSpy(el, options);
  window.onload = instance.onScroll();
  window.addEventListener('scroll', function () {
    return instance.onScroll();
  });
  return instance;
};